import React from 'react';
import { hydrateRoot } from 'react-dom/client';

import { Header } from '@hz-design-system/web-ui';
import { I18nContextProvider } from '@ecg-marktplaats/js-react-i18n';

import ExpiredListingApp from '../../apps/ExpiredListingApp/ExpierdListingApp';

import { trackGAEvent } from '../../utils/gaTracking';

import '../../../scss/global.scss';
import '../../../scss/layout.scss';

// server side only components styles for this page
import '../../../../server/pages/eVip.styles';

export default (i18n) => {
  // eslint-disable-next-line no-underscore-dangle
  const headerConfig = window.__HEADER_CONFIG__ || {};
  const environment = window.__ENV_CONFIG__ || {};
  const appState = window.__CONFIG__ || {};

  const smartBannerAndroidRoot = document.getElementById('smart-banner-android-root');
  const headerRootContainer = document.getElementById('header-root');
  const ExpierdListingRoot = document.getElementById('expired-listing-root');
  const evipSimilarItemsRoot = document.getElementById('evip-similar-items-root');

  // Render smart banner for Android
  // in case when this is not an Android there is no element to hydrate
  // @ts-ignore
  if (environment?.hasSmartBannerAndroidEnabled) {
    const loadComponent = async () => {
      try {
        const SmartBannerAndroidApp = (
          await import(
            /* webpackChunkName: "SmartBannerAndroidApp" */ '../../apps/SmartBannerAndroidApp/SmartBannerAndroidApp'
          )
        ).default;
        hydrateRoot(smartBannerAndroidRoot!, <SmartBannerAndroidApp />);
      } catch (err) {}
    };
    loadComponent();
  }

  // Header is server side rendered in express-react library
  hydrateRoot(headerRootContainer!, <Header headerConfig={headerConfig} trackGAEvent={trackGAEvent} />);

  hydrateRoot(ExpierdListingRoot!, <ExpiredListingApp itemId={appState.itemId} />);

  import('../../apps/EvpSimilarItemsApp/EvipSimilarItemsApp').then(({ default: EvipSimilarItemsApp }) =>
    hydrateRoot(
      evipSimilarItemsRoot!,
      <I18nContextProvider i18nInstance={i18n}>
        <EvipSimilarItemsApp environment={environment} eVipSimilarItems={appState.eVipSimilarItems} />
      </I18nContextProvider>,
    ),
  );
};
